<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <corporation-form />
  </v-container>
</template>

<script>

import CorporationForm from './_Form'

export default {
  name: 'AdminContractorEdit',
  components: {
    CorporationForm
  },
  mixins: [],
  data () {
    return {
      breadcrumbs:[
        { text: '契約者一覧', disabled: false, to: '/admin/contractors', exact: true },
        { text: '契約者編集', disabled: true, to: '' },
      ]
    }
  },
}
</script>

<style scoped>

</style>
